import { render, staticRenderFns } from "./AscRemovalsTimelineWrapper.vue?vue&type=template&id=528c5e24&"
import script from "./AscRemovalsTimelineWrapper.vue?vue&type=script&lang=js&"
export * from "./AscRemovalsTimelineWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscRemovalsTimelineWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports